import React from 'react'
import { Layout, Row, Col } from 'antd'
import './authLayout.less'
import { useEffect } from 'react'
import { useRef } from 'react'
import { Bibliotheca } from '../../../images'
import {Dropdown} from '../../../../bit_components/common/dropdown';

const { Header, Content } = Layout
let offset: string = '0px'
let customStyle: any = {}

const AuthLayout = (props: any) => {
  const ref = useRef(null)

  useEffect(() => {
    const windowOnLoad = (e: any) => {
      if (ref?.current) {
        let currentRef: any = ref.current
        offset = currentRef.clientHeight + 'px'
        customStyle.minHeight = `calc(100vh - ${offset})`
      }
    }

    const windowOnResize = (e: any) => {
      if (ref?.current) {
        let currentRef: any = ref.current
        offset = currentRef.clientHeight + 'px'
        customStyle.minHeight = `calc(100vh - ${offset})`
      }
    }

    window.addEventListener('load', windowOnLoad)
    window.addEventListener('resize', windowOnResize)

    return () => {
      window.removeEventListener('load', windowOnLoad)
      window.removeEventListener('resize', windowOnResize)
    }
  }, [])

  const language = [{ text: 'English', value: 0 }]

  return (
    <Layout className="scrollContent scrollStyle scrollAuth bitDropdown" >
      <div ref={ref}>
        <Header>
          <Row justify='space-between' className="login-header">
            <Col>
              <div>
                <img className='loginLogoHed' src={Bibliotheca} alt='JUNTO'/>
              </div>
            </Col>
            {window.location.pathname.includes("create-password") ?
            null :
            <Col>
              <Dropdown
                className='dropdownFix'
                defaultValue='English'
                optionValue={language}
                childwidth={true}
                optionClass="loginDropdown"
              />
            </Col>
            }
          </Row>
        </Header>
      </div>
      <Content>
        <Row justify='space-around'>
          <Col md={10} lg={8}>{props.children}</Col>
        </Row>
      </Content>
    </Layout>
  )
}

export default AuthLayout
